import * as React from 'react';
import { Helmet } from 'react-helmet';
import 'focus-visible';

import '@fontsource/work-sans/400.css';
import '@fontsource/work-sans/500.css';
import '@fontsource/work-sans/600.css';
import '@fontsource/work-sans/700.css';

import './style.scss';

import Header from '../Header';
import Footer from '../Footer';

const Layout = ({ pageTitle, children }) => {
  return (
    <main className="layout">
      <Helmet
        htmlAttributes={{
          lang: 'en',
        }}
      >
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="The Professional Standards Councils and its agency, the Professional Standards Authority, work to improve professional standards and protect consumers of professional services across Australia."
        />

        <title>{pageTitle} | Professional Standards Councils</title>

        <meta property="og:url" content="https://www.psc.gov.au/annual-report-2021-2022/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Home | Professional Standards Councils" />
        <meta property="og:description" content="The Professional Standards Councils and its agency, the Professional Standards Authority, work to improve professional standards and protect consumers of professional services across Australia." />
        <meta property="og:image" content="/og.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="psc.gov.au" />
        <meta property="twitter:url" content="https://www.psc.gov.au/annual-report-2021-2022/" />
        <meta name="twitter:title" content="Home | Professional Standards Councils" />
        <meta name="twitter:description" content="The Professional Standards Councils and its agency, the Professional Standards Authority, work to improve professional standards and protect consumers of professional services across Australia." />
        <meta name="twitter:image" content="/og.png" />
      </Helmet>

      <Header />

      <main>{children}</main>

      <Footer />
    </main>
  );
};

export default Layout;
